import React, { useContext } from "react";
import Box from "@mui/material/Box";
import MatchRatio from "../../../../components/MatchRatio";
import PersonnelId from "../molecules/PersonnelId";
import HeadInfoListItem from "../molecules/HeadInfoListItem";
import BodyInfoListItem from "../molecules/BodyInfoListItem";
import AttachmentFile from "../molecules/AttachmentFile";
import AdminComment from "../molecules/AdminComment";
import SideBar from "./SideBar";
import { personnelDetailContext } from "../../PersonnelDetail";

export default function MainContents() {
  const { personnelList = [], matchingIndex } = useContext(personnelDetailContext);
  const currentPersonnel = personnelList[matchingIndex];

  if (!currentPersonnel) {
    return (
      <Box
        sx={{ backgroundColor: "white", borderRadius: "5px", height: "730px" }}
      />
    );
  }

  const costVal = currentPersonnel.cost ? Number(currentPersonnel.cost) : 0.0;
  const headInfoList = [
    {
      head: "単価",
      text: `${costVal.toLocaleString()}万円`,
    },
  ];

  const bodyInfoList = [
    {
      head: "商流の程度",
      text: currentPersonnel.personnel_business_label || "",
    },
    {
      head: "稼働開始予定",
      text: currentPersonnel.actual_work || "未定",
    },
    { head: "年齢", text: currentPersonnel.age || "" },
    {
      head: "性別",
      text: currentPersonnel.gender || "無回答",
    },
    { head: "技術提供企業", text: currentPersonnel.belonging || "" },
    {
      head: "キーワード",
      text: currentPersonnel.match_words || "なし",
    },
  ];

  return (
    <>
      <Box sx={{ backgroundColor: "white", borderRadius: "5px" }}>
        <Box
          sx={{
            display: "flex",
            height: "auto",
            p: "20px",
            borderBottom: { sm: 1.5 },
            borderColor: "#4c4c4c",
            gap: "40px",
            marginTop: "40px",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <PersonnelId personnelId={currentPersonnel.id} />
            {headInfoList.map((item) => (
              <HeadInfoListItem
                key={item.head}
                head={item.head}
                text={item.text}
              />
            ))}
          </Box>
          <MatchRatio
            ratio={currentPersonnel.match_ratio}
            width={{ xs: "80px", sm: "120px" }}
            mainFontSize={{ xs: "30px", sm: "50px" }}
            subFontSize={{ xs: "10px", sm: "12px" }}
          />
        </Box>
      </Box>

      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <SideBar />
      </Box>

      <Box sx={{ backgroundColor: "white", borderRadius: "5px" }}>
        <Box sx={{ borderTop: 1, borderColor: "grey.300" }}>
          {bodyInfoList.map((item) => (
            <BodyInfoListItem
              key={item.head}
              head={item.head}
              text={item.text}
            />
          ))}
          <AttachmentFile
            id={currentPersonnel.id}
            filename={currentPersonnel.mail_attachment_filename}
          />
        </Box>
        <AdminComment text={currentPersonnel.comment || "コメントはありません"} />
      </Box>
    </>
  );
}